// Card animation duration in ms — matches server dealing cadence (~300-350ms per card).
export const CARD_ANIM_DURATION = 350
